import type { FC } from 'react';

import { I18nProvider, useTranslation } from '@eneco/i18n';

import { TrackedNotificationBox } from '../../TrackedNotificationBox/TrackedNotificationBox';

export const ComponentError: FC<{ message?: string }> = ({ message }) => {
  return (
    <I18nProvider dictionary={locale => import(`./content/${locale}.json`)}>
      <InnerComponentError message={message} />
    </I18nProvider>
  );
};

const InnerComponentError: FC<{ message?: string }> = ({ message }) => {
  const { t } = useTranslation();

  return <TrackedNotificationBox title={t('title')} text={message || t('message')} variant="error" isAlert={false} />;
};

export default ComponentError;
